var map = {
	"./3dcapsule.png": 23,
	"./3dtriangle.png": 22,
	"./3dtube.png": 21,
	"./Arrow Right.svg": 15,
	"./Design.svg": 58,
	"./Develope.svg": 59,
	"./Support.svg": 60,
	"./Website Image-1.png": 61,
	"./Website Image-2.png": 62,
	"./Website Image-3.png": 63,
	"./arrow-up.svg": 24,
	"./assets/3dcapsule.png": 64,
	"./assets/3dtriangle.png": 65,
	"./assets/3dtube.png": 66,
	"./assets/Arrow Right.svg": 67,
	"./assets/Design.svg": 68,
	"./assets/Develope.svg": 69,
	"./assets/Support.svg": 70,
	"./assets/Website Image-1.png": 71,
	"./assets/Website Image-2.png": 72,
	"./assets/Website Image-3.png": 73,
	"./assets/arrow-up.svg": 74,
	"./assets/avatar-1.jpg": 40,
	"./assets/avatar-2.jpg": 41,
	"./assets/avatar-3.jpg": 42,
	"./assets/avatar-4.jpg": 43,
	"./assets/blob purple.png": 75,
	"./assets/blob white.png": 76,
	"./assets/blobPink.png": 77,
	"./assets/envelope-open-solid.svg": 78,
	"./assets/facebook-square-brands.svg": 79,
	"./assets/hand.svg": 80,
	"./assets/human.svg": 81,
	"./assets/instagram-square-brands.svg": 82,
	"./assets/linkedin-brands.svg": 83,
	"./assets/logo.svg": 84,
	"./assets/mobile.svg": 85,
	"./assets/rocket image.png": 86,
	"./assets/twitter-square-brands.svg": 87,
	"./assets/waves.svg": 88,
	"./avatar-1.jpg": 44,
	"./avatar-2.jpg": 45,
	"./avatar-3.jpg": 46,
	"./avatar-4.jpg": 47,
	"./blob purple.png": 13,
	"./blob white.png": 14,
	"./blobPink.png": 12,
	"./envelope-open-solid.svg": 25,
	"./facebook-square-brands.svg": 26,
	"./hand.svg": 20,
	"./human.svg": 19,
	"./instagram-square-brands.svg": 7,
	"./linkedin-brands.svg": 27,
	"./logo.svg": 28,
	"./mobile.svg": 16,
	"./rocket image.png": 18,
	"./twitter-square-brands.svg": 8,
	"./waves.svg": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;